import { isNullOrEmpty } from './types'

export * from './types'
export * from './dateHelper'

export * from './fuckIOS12'

export * from './device'

export * from './geolocation'

export * from './jsonp'

export * from './order/getOrderMoneyPayType'

/**
 * 手机号码格式化
 * {3} {4} {4}
 * @param {string} tel
 */
export const formatTEL = tel => {
  if (isNullOrEmpty(tel)) return ''
  if (tel.length !== 11) return tel
  return tel.replace(/^(\d{3})(\d{4})(\d{4})$/, '$1 $2 $3')
}

export const maskTEL = tel => {
  if (isNullOrEmpty(tel)) return ''
  if (tel.length !== 11) return tel
  return tel.replace(/^(\d{3})(\d{4})(\d{4})$/, '$1 **** $3')
}

export const getRandom = () => Math.random(0, 1).toString().substr(2)

export const getGUID = () => Math.random().toString().substr(2)
